import { render, staticRenderFns } from "./RulesDialog.vue?vue&type=template&id=5e3bba93&scoped=true&"
import script from "./RulesDialog.vue?vue&type=script&lang=ts&"
export * from "./RulesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RulesDialog.vue?vue&type=style&index=0&id=5e3bba93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3bba93",
  null
  
)

export default component.exports